export const PASSWORD_REGEX =
  /(?=^.{10,}$)((?!.*[^a-zA-Z0-9])|(?=.*\W+))(?=.*\d)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
export const JUST_ENTER_NUMBER_REGEX = /^[0-9\b]+$/;
export const EMAIL_REGEX =
  /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; /* eslint-disable-line */
